import React from 'react';
import FaStatusBadge from './FaStatusBadge';
import PlayerTypeBadge from './PlayerTypeBadge';

export default function PlayerNameBadges({ player, size = 'normal', showPlayerType = true }) {
  if (!player) return null;

  const faBadge = player.faStatus ? <FaStatusBadge status={player.faStatus} size={size} /> : null;
  const typeBadge = showPlayerType ? <PlayerTypeBadge player={player} size={size} /> : null;

  if (!faBadge && !typeBadge) return null;

  const groupClass = [
    'player-badges-group',
    `player-badges-group-${size}`,
    showPlayerType ? '' : 'player-badges-group-goalie-only',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={groupClass}>
      <span className="player-badge-slot player-badge-slot-fa">{faBadge}</span>
      {showPlayerType ? (
        <span className="player-badge-slot player-badge-slot-type">{typeBadge}</span>
      ) : null}
    </span>
  );
}
